import { isAIGenPhoto, isArtPhoto } from '@mixtiles/web-backend-shared'
import countBy from 'lodash/countBy'
import sumBy from 'lodash/sumBy'
import { type Tile } from 'components/TilesProvider/TilesProvider.types'
import { getPhotoBooksStore, getTilesStore } from 'stores/RootStoreProvider'
import { readOutsideReaction } from 'utils/mobx/readOutsideReaction'

type CountableProductItem = Partial<Tile>

function getAIGenTilesCountByCategory(items: CountableProductItem[]) {
  return countBy(
    items
      .filter(isAIGenPhoto)
      .map((item) => item.aiTemplate?.templateCategory)
      .filter(Boolean)
  )
}

export function generateProductCountEventProperties(
  pendingTiles: CountableProductItem[] = []
) {
  const tiles: CountableProductItem[] = [
    ...readOutsideReaction(() => getTilesStore().providerTiles),
    ...pendingTiles,
  ]
  const artTilesCount = tiles.filter(isArtPhoto).length
  const aiGenTilesCount = tiles.filter(isAIGenPhoto).length

  const photoBookPhotosCount = readOutsideReaction(() =>
    sumBy(
      Array.from(getPhotoBooksStore().booksMap.values()),
      (bookStore) => bookStore.photosCount
    )
  )
  return {
    'Tiles Count': tiles.length - artTilesCount - aiGenTilesCount,
    'Art Tiles Count': artTilesCount,
    'AI Gen Tiles Count': aiGenTilesCount,
    'AI Gen Tiles Count By Category': getAIGenTilesCountByCategory(tiles),
    'Photo Book Photos Count': photoBookPhotosCount,
  }
}
